import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['direct-consortium-group-files'],
  queryOptions: {},
};

const getDirectConsortiumGroupFiles = async (directID, cgId, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/directs/${directID}/consortium_groups/${cgId}/files?${queryString}`);

  return { files: data || [], total };
};

export const useDirectsConsortiumGroupFiles = (directID, cgId, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, cgId], () => getDirectConsortiumGroupFiles(directID, cgId, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};